import { isObject } from '@principle-theorem/shared';
import { get } from 'lodash';

export function resolveHelpArticleId(
  routeSegments: string[]
): number | undefined {
  const result = get(
    INTERCOM_CONTEXTUAL_HELP_IDS,
    routeSegments[routeSegments.length - 1],
    undefined
  );

  if (isObject(result)) {
    const foundSegment = routeSegments
      .slice(0, -1)
      .reverse()
      .find((segment) => !!result[segment]);

    return foundSegment
      ? result[foundSegment]
      : get(result, 'default', undefined);
  }

  return result;
}

const INTERCOM_CONTEXTUAL_HELP_IDS: Record<
  string,
  number | Record<string, number | undefined>
> = {
  accounting: 9044751,
  'appointment-requests': 5348763,
  automations: {
    brand: 9044816,
    default: 9042352,
  },
  calendar: 5059396,
  campaigns: 12749298,
  'cancellation-reasons': 9068917,
  chats: 9044487,
  conditions: 4665922,
  contacts: 4405582,
  conversations: 9044452,
  'custom-reports': 9054207,
  dashboard: 4517372,
  'document-templates': 5334723,
  'fee-schedules': 5209490,
  gaps: 5147382,
  'follow-ups': 5147556,
  general: {
    brand: 9044745,
  },
  history: {
    default: undefined,
    schedule: 9393250,
  },
  integrations: 9044662,
  'lab-jobs': 9003061,
  labs: 9003061,
  list: 4343835,
  'multi-treatments': 5378269,
  'outstanding-invoices': 6214551,
  'patient-reports': 9059234,
  patients: {
    default: 5178195,
    reporting: 9059234,
  },
  'pending-payments': 6239809,
  practitioner: 5084145,
  products: 5341517,
  profile: 5212555,
  'practitioner-income': 6151007,
  reconciliation: 5664266,
  'referral-sources': 9068843,
  'report-builder': 9054207,
  roles: 6974682,
  snippets: 4527447,
  staff: {
    brand: 5471667,
    default: 9042022,
  },
  tags: 5244598,
  teams: 9045620,
  timeline: 5171973,
  treatments: 4665942,
  'treatment-categories': 5570378,
  'treatment-templates': 5052024,
  users: 4527402,
};
